import { useEffect, useState } from "react";
import PromptManagementStyles from "./PromptManagement.module.scss";

import InfoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import DownArrow from "../../../../assets/images/DownAccordianArrow.svg";

import { useAppDispatch } from "../../../../hooks/store";
import { updateClause } from "../../store/admin.thunk";
import { PromptsForFeature } from "../../constants";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import Typography from "../../../../components/Typography/Typography";
import Button from "../../../../components/Button/Button";
import { SimpleButton } from "../../../../components/Buttons/Buttons";
import { getRefinedValuePerUnit } from "../../util";
import { Popover } from "antd";

const PromptManagementForContractReview = ({ prompt }: any) => {
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [dataObj, setDataObj] = useState({
    id: "",
    name: "",
    value: "",
    isDefaultVal: false,
  });
  const [isAccordianExpanded, setIsAccordianExpanded] = useState(false);
  const showEditButton = isAccordianExpanded && !isEditing;
  const showEditAndSaveButton = isAccordianExpanded && isEditing;

  const handleOnCancel = (e: any) => {
    e.stopPropagation();
    setIsEditing(false);
    setDataObj({ id: "", name: "", value: "", isDefaultVal: false });
  };

  const handleSave = async () => {
    await dispatch(
      updateClause({
        feature: PromptsForFeature.CONTRACT_REVIEW,
        clauseId: dataObj?.id,
        name: dataObj?.name,
        value: dataObj?.value,
        isDefaultVal: dataObj?.isDefaultVal,
      })
    );
    setDataObj({ id: "", name: "", value: "", isDefaultVal: false });
    setIsEditing(false);
  };

  return (
    <Accordion
      className={PromptManagementStyles.promptAccordion}
      style={{
        padding: "5px",
        borderRadius: "10px",
        background: "var(--primaryWhiteColor)",
        boxShadow: "none",
        border: "1px solid #EAECED",
      }}
      onChange={(e, expanded) => {
        if (expanded) {
          setIsAccordianExpanded(true);
        } else {
          setIsEditing(false);
          setIsAccordianExpanded(false);
        }
      }}
      disabled={!prompt?.isEnabled}
    >
      <AccordionSummary
        expandIcon={<img src={DownArrow} alt="downArrow" />}
        style={{
          height: "50px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            fontSize={18}
            lineHeight="26px"
            fontWeight={500}
            color="var(--secondaryBlackColor)"
          >
            {prompt?.displayName || "Clause"}
          </Typography>
          {showEditButton && (
            <Button
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(true);
              }}
              style={{
                padding: "6px 16px",
                marginRight: "15px",
              }}
            >
              <Typography fontSize={14} fontWeight={500} lineHeight="20px">
                Edit
              </Typography>
            </Button>
          )}
          {showEditAndSaveButton && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                marginRight: "15px",
              }}
            >
              <SimpleButton variant="outlined" onClick={handleOnCancel}>
                <Typography fontSize={14} fontWeight={500} lineHeight="20px">
                  Cancel
                </Typography>
              </SimpleButton>
              <SimpleButton
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSave();
                }}
              >
                <Typography fontSize={14} fontWeight={500} lineHeight="20px">
                  Save
                </Typography>
              </SimpleButton>
            </div>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "12px 20px",
            backgroundColor: !isEditing
              ? "var(--primaryWhiteColor)"
              : "var(--text-field_disabled_bgColor)",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              fontSize={16}
              fontWeight={500}
              lineHeight="20px"
              color="var(--text-field_grey_textColor)"
            >
              Threshold
            </Typography>
          </div>
          <div className={PromptManagementStyles.promptTextContainer}>
            {prompt?.rules?.map((item: any, idx: number) => (
              <AccordionDetailsCompForContractReview
                key={item?.name}
                item={item}
                isEditing={isEditing}
                setDataObj={setDataObj}
                labelRule={prompt?.labelRules[idx]}
                labelDescription={prompt?.threshold[idx]}
                id={prompt?.id}
              />
            ))}
          </div>

          {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                fontSize={16}
                fontWeight={500}
                lineHeight="20px"
                color="var(--text-field_grey_textColor)"
              >
                Rules
              </Typography>
              <Tooltip
                title={
                  <Typography>
                    Power user can edit the rules used for the clause
                  </Typography>
                }
                placement="right"
              >
                <img src={InfoIconSvg} alt="" height={16} width={16} />
              </Tooltip>
            </div>
            <TextField
              minRows={3}
              multiline={true}
              fullWidth={true}
              disabled={!isEditing}
              value={parseNextLine(value)}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              slotProps={{
                input: {
                  style: {
                    backgroundColor: !isEditing
                      ? "var(--primaryWhiteColor)"
                      : "var(--text-field_disabled_bgColor)",
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 500,
                    color: "var(--text-field_prompt_textColor)",
                    borderRadius: "8px",
                  },
                },
              }}
              sx={{ border: "none", "& fieldset": { border: "none" } }}
            /> */}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export const AccordionDetailsCompForContractReview = ({
  item,
  isEditing,
  id,
  labelRule,
  setDataObj,
  labelDescription,
  style,
}: any) => {
  const [value, setValue] = useState(item?.count);
  const handleChange = (e: any) => {
    const val = e.target?.value;
    const isDefaultVal = val === "" || val === "0";
    if (val < item?.min || val > item?.max) {
      return;
    }
    setDataObj({
      id: id,
      value: getRefinedValuePerUnit(item, val, isDefaultVal),
      name: item?.name,
      isDefaultVal: isDefaultVal,
    });
    setValue(val);
  };

  useEffect(() => {
    if (!isEditing) {
      setValue(item?.count);
    }
  }, [isEditing, item?.count]);

  return (
    <div className={PromptManagementStyles.promptSubClauseCondition}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          width: "70%",
          ...style,
        }}
      >
        <Typography
          fontSize={12}
          fontWeight={500}
          color="#000000CC"
        >
          {item?.name}:
        </Typography>
        <Typography
          fontSize={12}
          fontWeight={400}
          color="#00000099"
        >
          {labelDescription?.value}
        </Typography>
      </div>
      <div className={PromptManagementStyles.promptSubClauseInput}>
        <Typography
          fontSize={12}
          fontWeight={400}
          color="#00000099"
        >
          {labelDescription?.isMax ? "Max" : "Min"}
        </Typography>
        <div
          className={PromptManagementStyles.promptSubClauseInputField}
          style={{
            backgroundColor: isEditing ? "var(--primaryWhiteColor)" : "",
            borderRadius: "8px",
            border: isEditing
              ? "1px solid #B6C0D1"
              : "",
          }}
        >
          <TextField
            type="number"
            style={{
              width: "50%",
            }}
            disabled={!isEditing}
            value={value}
            onChange={handleChange}
            slotProps={{
              input: {
                style: {
                  fontSize: "12px",
                  lineHeight: "20px",
                  fontWeight: 500,
                  color: !isEditing ? "#00000099" : "#000000",
                },
              },
            }}
            sx={{
              border: "none",
              "& fieldset": { border: "none" },
              "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button":
                {
                  WebkitAppearance: "none",
                  margin: 0,
                },
              "input[type=number]": {
                MozAppearance: "textfield",
                padding: "0px",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: !isEditing ? "#00000099" : "#000000",
              },
            }}
          />
          <Typography
            fontSize={14}
            fontWeight={400}
            lineHeight="18px"
            color="var(--text-field_input_textColor)"
          >
            {item?.unit}
          </Typography>
        </div>
        <Popover
          content={
            <div
              style={{
                width: "350px",
                minHeight: "fit-content",
                maxHeight: "150px",
                height: "auto",
                overflowY: "auto",
                padding: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <Typography
                  fontWeight={500}
                  fontSize={16}
                  color="var(--text-field_prompt_textColor)"
                >
                  Rule
                </Typography>

                <div>
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "var(--primaryGrey3Color)",
                    }}
                  >
                    {labelRule?.startString}
                  </span>
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "var(--primaryBlackColor)",
                    }}
                  >
                    {item?.count} {item?.unit}
                  </span>
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "var(--primaryGrey3Color)",
                    }}
                  >
                    {" "}
                    {labelRule?.endString}
                  </span>
                </div>
              </div>
            </div>
          }
          trigger="hover"
          placement="right"
        >
          <img src={InfoIconSvg} alt="" style={{width: "16px", height: "16px"}} />
        </Popover>
      </div>
    </div>
  );
};

export default PromptManagementForContractReview;
